<script>
import BlockingContainer from '@components/BlockingContainer';
import HeaderComponent from '@components/HeaderComponent';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Layout from '@layouts/main';
import DownloadCategoryModel from '@models/DownloadCategory';

export default {
  name: 'DownloadCategoriesIndex',
  page() {
    return { title: this.$t('titles.download_categories') };
  },
  components: {
    FontAwesomeIcon,
    BlockingContainer,
    HeaderComponent,
    Layout,
  },
  data() {
    return {
      categories: [],
      isBusy: false,
      fieldsTable: [
        { key: 'name', label: this.$t('table_labels.name'), sortable: false },
        { key: 'show_remark', label: this.$t('fields.show_remark'), sortable: false },
        { key: 'show_google_link', label: this.$t('fields.show_google_link'), sortable: false },
        { key: 'actions', label: this.$t('table_labels.actions'), sortable: false },
      ],
    };
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      this.isBusy = true;
      DownloadCategoryModel.orderBy('name')
        .get()
        .then((response) => {
          this.categories = response.data || response;
          this.isBusy = false;
        })
        .catch(() => { this.isBusy = false; });
    },
    async deleteCategory(item) {
      if (confirm(this.$t('alerts.delete_entity', { entity: this.$t('entities.download_category') }))) {
        this.$wait.start(`category ${item.id} processing`);
        const record = new DownloadCategoryModel({ id: item.id });
        await record.delete();
        this.$wait.end(`category ${item.id} processing`);
        this.loadCategories();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-row class="mb-4">
      <b-col>
        <HeaderComponent
          :title="$t('titles.download_categories')"
          :button-text="$t('titles.create_download_category')"
          @button-pressed="$router.push({ name: 'downloadCategories.create' })"
        />
      </b-col>
    </b-row>

    <div class="position-relative">
      <BlockingContainer v-if="$wait.is('categories processing') || isBusy" />

      <b-table
        small
        striped
        :items="categories"
        :fields="fieldsTable"
        :show-empty="true"
      >
        <template #cell(show_remark)="row">
          <FontAwesomeIcon v-if="row.item.show_remark" :icon="['fas', 'check-circle']" class="text-success" />
          <FontAwesomeIcon v-else :icon="['fas', 'times-circle']" class="text-danger" />
        </template>

        <template #cell(show_google_link)="row">
          <FontAwesomeIcon v-if="row.item.show_google_link" :icon="['fas', 'check-circle']" class="text-success" />
          <FontAwesomeIcon v-else :icon="['fas', 'times-circle']" class="text-danger" />
        </template>

        <template #cell(actions)="row">
          <div class="d-flex" style="gap: 4px;">
            <b-btn
              size="sm"
              variant="outline-primary"
              :to="{ name: 'downloadCategories.edit', params: { id: row.item.id } }"
            >
              <FontAwesomeIcon :icon="['fas', 'edit']" />
            </b-btn>
            <b-btn
              size="sm"
              variant="outline-danger"
              :disabled="$wait.is(`category ${row.item.id} processing`)"
              @click.stop="deleteCategory(row.item)"
            >
              <FontAwesomeIcon :icon="['fas', 'times-circle']" />
            </b-btn>
          </div>
        </template>

        <template #empty>
          <div class="text-center">{{ $t('messages.no_items') }}</div>
        </template>
      </b-table>
    </div>
  </Layout>
</template>
